import { ErrorSeverities, ErrorTypes } from '../constants';

const appConfig = {
  accessPIN: {
    maxLength: 6,
    maxAttempts: 5,
  },
  commitHash: process.env.REACT_APP_COMMIT_HASH,
  displayHeaderDate: true,
  displayHeaderHomeIcon: false,
  displayJSONBlob: true,
  errorDisplayMapping: {
    [ErrorTypes.EXPIRED]: ErrorSeverities.CRITICAL,
    [ErrorTypes.GENERATING]: ErrorSeverities.GENERATING,
    [ErrorTypes.NOT_FOUND]: ErrorSeverities.CRITICAL,
    [ErrorTypes.PAGE_NOT_FOUND]: ErrorSeverities.CRITICAL,
    [ErrorTypes.UNKNOWN]: ErrorSeverities.CRITICAL,
  },
  milestone: process.env.REACT_APP_MILESTONE,
  spec: 'psca',
  version: process.env.REACT_APP_VERSION,
};
export default appConfig;
